import { clsx } from "clsx";
import { type FC } from "react";

import { type ProfileVariantData } from "../../../../graphql.js";
import { TooltipController } from "../../overlays/components/OverlayControllers.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

// meant for VCF Variants
const AlternativeVariantProfileCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value?.length) {
    return null;
  }

  const profiles: ProfileVariantData[] = props.data.profileVariant;

  return (
    <TableCell>
      <div className="variant-profile-wrapper">
        {profiles?.map((profile: ProfileVariantData, index: number) => {
          const genomeName: string = profile.genomeName;

          const tooltip = `${genomeName}: ${profile.noCall ? "no-call" : profile.present ? "present" : "absent"} ${
            profile.heterozygous ? `(Heterozygous)` : ""
          }`;
          return (
            <TooltipController content={tooltip} key={`variant-profile-tooltip-${props.data.id}-${index}`}>
              {(tooltipTriggerProps) => (
                <div
                  className={clsx({
                    "profile-char-present": profile.present,
                    "profile-char-absent": !profile.present,
                    "profile-heterozygous": profile.heterozygous,
                    "profile-no-call": profile.noCall,
                  })}
                  key={`variant-profile-${props.data.id}-${index}`}
                  {...tooltipTriggerProps}
                />
              )}
            </TooltipController>
          );
        })}
      </div>
    </TableCell>
  );
};

export default AlternativeVariantProfileCell;
